import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import './LeaderboardIframeWidget.scss';

interface LeaderboardIframeWidgetProps {
    src: string;
    title?: string;
}

const LeaderboardIframeWidget: React.FC<LeaderboardIframeWidgetProps> = ({ src, title }) => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className="leaderboardIframeContainer">
            {isLoading && (
                <div className="leaderboardIframeSpinner">
                    <CircularProgress size={70} />
                </div>
            )}
            <iframe
                src={src}
                title={title ?? 'Leaderboard'}
                className="leaderboardIframe"
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                onLoad={() => setIsLoading(false)}
                style={{ visibility: isLoading ? 'hidden' : 'visible' }}
            />
        </div>
    );
};

export default LeaderboardIframeWidget;
